import { render, staticRenderFns } from "./StudentWelcome.vue?vue&type=template&id=15d66a7c"
import script from "./StudentWelcome.vue?vue&type=script&lang=js"
export * from "./StudentWelcome.vue?vue&type=script&lang=js"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./StudentWelcome.vue?vue&type=style&index=1&id=15d66a7c&prod&lang=css"
import style2 from "./StudentWelcome.vue?vue&type=style&index=2&id=15d66a7c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports